import { GroupResponse } from "@/features/group/models/GroupResponse";
import { PackageGroupResponse } from "../../../features/group/models/PackageGroupResponse";
import { PackageResponse } from "../../../features/subscriptions/modules/packages/models/PackageResponse";

export class PackageGroupClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = baseURL;
  }

  async list() {
    const url = this.baseURL;

    const response = await this.httpClient.request("get", url);

    return response.data.result.map(item => new GroupResponse(item));
  }

  async get(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("get", url);

    return new PackageGroupResponse(response.data.result);
  }

  async put(id, params) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async getAllPackage() {
    const url = `${this.baseURL}/packages/all`;

    const response = await this.httpClient.request("get", url);

    return response.data.result.map(item => new PackageResponse(item));
  }

  async post(params) {
    const url = this.baseURL;

    await this.httpClient.request("post", url, {
      data: params
    });
  }

  async delete(id) {
    const url = `${this.baseURL}/${id}`;

    const response = await this.httpClient.request("delete", url);

    return response;
  }
}
